import React from "react";
import { NavLink } from "react-router-dom";
import { formatMonthLabel, shiftMonth } from "./financeUtils";
import "../../finance.css";

const TABS = [
  { pathname: "/finance", label: "Обзор", end: true },
  { pathname: "/finance/accounts", label: "Фонды и счета" },
  { pathname: "/finance/payments", label: "Платежи" },
  { pathname: "/finance/payroll", label: "Зарплата" },
  { pathname: "/finance/income", label: "Приход" },
];

export default function FinanceTabs({ month, onMonthChange, title }) {
  void title;
  return (
    <header className="fin-desk">
      <h2 className="fin-desk-title">Финансы</h2>

      <div className="cp-month-nav" role="group" aria-label="Месяц">
        <button
          type="button"
          className="cd-sort-btn"
          aria-label="Предыдущий месяц"
          onClick={() => onMonthChange(shiftMonth(month, -1))}
        >
          ←
        </button>
        <div className="cp-month-label">{formatMonthLabel(month)}</div>
        <button
          type="button"
          className="cd-sort-btn"
          aria-label="Следующий месяц"
          onClick={() => onMonthChange(shiftMonth(month, 1))}
        >
          →
        </button>
      </div>

      <nav className="fin-tabs" aria-label="Разделы финансов">
        {TABS.map((tab) => (
          <NavLink
            key={tab.pathname}
            to={{ pathname: tab.pathname, search: `?month=${month}` }}
            end={Boolean(tab.end)}
            className={({ isActive }) => (isActive ? "fin-tab-active" : undefined)}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
